import { render, staticRenderFns } from "./filters.vue?vue&type=template&id=7b918d97&"
import script from "./filters.vue?vue&type=script&lang=ts&"
export * from "./filters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('7b918d97', component.options)
    } else {
      api.reload('7b918d97', component.options)
    }
    module.hot.accept("./filters.vue?vue&type=template&id=7b918d97&", function () {
      api.rerender('7b918d97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/SucursalVirtual/MisSolicitudes/filters.vue"
export default component.exports